import {
  ButtonPrimeReact,
  FileStatus,
  PrimeReactModal,
} from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import DropzoneComponent from "common/components/DropzoneComponent/DropzoneComponent"
import Modal from "common/components/Modal/Modal"
import { MODAL_STYLES } from "constants/primereactStyles"
import { FormikDocumentsProps } from "features/Crear/pages/FormCreacionDocumento/CreacionDocumento"
import {
  TYPES_DOCUMENTOS,
  getDocumentLabel,
} from "features/Crear/pages/FormCreacionDocumento/constant"
import { capitalize } from "features/User/utils"
import { AnimatePresence } from "framer-motion"
import { InputSwitch, InputSwitchChangeParams } from "primereact/inputswitch"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { encodeImageToBase64 } from "utils/encodeBase64"
import FormDescuentoDocuemnto from "../../../FormDocumentoCompletoStage/Forms/DescuentoDocument/DescuentoDocument"
import FormDiasPagoDocumento from "../../../FormDocumentoCompletoStage/Forms/DiasPagoDocument/DiasPagoDocument"
import FormFechaPagoOperacion from "../../../FormDocumentoCompletoStage/Forms/FechaOperacionesDocument/FechaOperacionesDocument"
import FormFormaPagoDocumento from "../../../FormDocumentoCompletoStage/Forms/FormaPagoDocumento/FormaPagoDocumento"
import FormNivelLogisticoAlbaran from "../../../FormDocumentoCompletoStage/Forms/NivelLogisticoAlbaran/NivelLogisticoAlbaran"
import FormObservacionesDocumento from "../../../FormDocumentoCompletoStage/Forms/ObservacionesDocument/ObservacionesDocument"
import FormRetencionDocuemnto from "../../../FormDocumentoCompletoStage/Forms/RetencionDocument/RetencionDocument"

const CardCampo = ({
  campo,
  checked,
  onChange,
  disabled,
}: {
  campo: string
  checked: boolean
  onChange: (e: InputSwitchChangeParams) => void
  disabled: boolean
}) => {
  return (
    <div className='tw-flex tw-flex-row tw-justify-between tw-items-center tw-w-full tw-py-4 tw-border-b tw-border-neutral-25'>
      <p className='tw-m-0'>{campo}</p>
      <InputSwitch
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
    </div>
  )
}
const CardNuevosCamposDocumentosSetting = ({
  values,
  setFieldValue,
}: FormikDocumentsProps) => {
  const { t } = useTranslation()
  const [fileStatus, setFileStatus] = useState<FileStatus | null>(null)

  const restartFileStatus = () => {
    setFileStatus({
      files: undefined,
      hasFile: false,
      isLoading: false,
      isDragging: false,
      draggedFilesCount: 0,
    })
  }

  return (
    <div className='tw-w-full tw-p-0-tw-mt-5 tw-text-left tw-flex tw-flex-col tw-mb-10'>
      <p className='tw-mb-2 tw-text-lg tw-font-medium'>
        {t("crear.facturaRec.settings.newFieldLabel")}
      </p>
      {values.documentoType.type !== TYPES_DOCUMENTOS.PROFORMA && (
        <>
          <CardCampo
            campo={`${t("crear.facturaRec.settings.addLogoLabel")}`}
            checked={Boolean(values?.logoAsBase64)}
            onChange={() => {
              if (values?.logoAsBase64) {
                setFieldValue("logoAsBase64", null)
                setFieldValue("logo", null)
              } else {
                setFieldValue(
                  "modals.showLogoModal",
                  !values.modals.showLogoModal
                )
              }
            }}
            disabled={false}
          />
          <CardCampo
            campo={`${t("crear.facturaRec.settings.operationDateLabel")}`}
            checked={Boolean(values?.fechaOperacion)}
            onChange={() =>
              values?.fechaOperacion
                ? setFieldValue("fechaOperacion", null)
                : setFieldValue(
                    "modals.showFechaOperacionModal",
                    !values.modals.showFechaOperacionModal
                  )
            }
            disabled={false}
          />
        </>
      )}
      <CardCampo
        campo={`${t("crear.facturaRec.settings.discountLabel")}`}
        checked={values?.config.sinValorar ? false : Boolean(values?.descuento)}
        disabled={values?.config.sinValorar}
        onChange={() =>
          values?.descuento
            ? setFieldValue("descuento", null)
            : setFieldValue(
                "modals.showDescuentoModal",
                !values?.modals.showDescuentoModal
              )
        }
      />
      <CardCampo
        campo={`${t("crear.facturaRec.settings.retencionLabel")}`}
        checked={
          values?.config.sinValorar ? false : Boolean(values?.retencionTipoId)
        }
        disabled={values?.config.sinValorar}
        onChange={() => {
          if (values?.retencionTipoId) {
            setFieldValue("retencionTipoId", null)
            setFieldValue("retencionPorcentaje", null)
          } else {
            setFieldValue(
              "modals.showRetencionModal",
              !values?.modals?.showRetencionModal
            )
          }
        }}
      />
      {values.documentoType.type !== TYPES_DOCUMENTOS.PROFORMA && (
        <>
          <CardCampo
            campo={`${t("crear.facturaRec.settings.observationLabel")}`}
            checked={Boolean(values?.observaciones)}
            onChange={() => {
              if (values?.observaciones) {
                setFieldValue("observaciones", null)
              } else {
                setFieldValue(
                  "modals.showObservacionesModal",
                  !values.modals.showObservacionesModal
                )
              }
            }}
            disabled={false}
          />
          <CardCampo
            campo={`${t("crear.facturaRec.settings.paymentFormLabel")}`}
            checked={Boolean(values?.formaPago)}
            onChange={() => {
              if (values?.formaPago) {
                setFieldValue("formaPago", null)
                setFieldValue("formaPagoIban", null)
                setFieldValue("formaPagoIbanInput", null)
                setFieldValue("formaPagoDescription", null)
              } else {
                setFieldValue(
                  "modals.showFormaPagoModal",
                  !values.modals.showFormaPagoModal
                )
              }
            }}
            disabled={false}
          />
          <CardCampo
            campo={`${t("crear.facturaRec.settings.paymentDayLabel")}`}
            checked={Boolean(values?.diasPago)}
            onChange={() =>
              values?.diasPago
                ? setFieldValue("diasPago", null)
                : setFieldValue(
                    "modals.showDiasPagoModal",
                    !values.modals.showDiasPagoModal
                  )
            }
            disabled={false}
          />
        </>
      )}
      {values.documentoType.type !== TYPES_DOCUMENTOS.FACTURA &&
        values.documentoType.type !== TYPES_DOCUMENTOS.PROFORMA &&
        values.documentoType.type !==
          TYPES_DOCUMENTOS.FACTURA_RECTIFICATIVA && (
          <CardCampo
            campo={`${capitalize(
              getDocumentLabel(values.documentoType.type, t)
            )}${t("crear.facturaRec.settings.notValorateLabel")}`}
            checked={values?.config.sinValorar}
            onChange={() =>
              setFieldValue("config.sinValorar", !values?.config.sinValorar)
            }
            disabled={false}
          />
        )}
      {values.documentoType.type === TYPES_DOCUMENTOS.ALBARAN &&
        values?.albaranLogistico?.niveles && (
          <div
            className='tw-bg-secondary hover:!tw-bg-secondary-over hover:tw-shadow tw-text-white tw-w-full tw-flex tw-items-center tw-justify-center tw-h-10 tw-rounded tw-cursor-pointer'
            onClick={() => setFieldValue("documentoType.screen", 4)}
          >
            Organizar embalaje
          </div>
        )}

      <AnimatePresence>
        <Modal
          key='modal-albaran-logistico'
          header='Niveles del albarán'
          size='small'
          onHide={() =>
            setFieldValue("modals.showAlbaranLogisticoModal", false)
          }
          maskClassName='!tw-z-50'
          visible={values.modals.showAlbaranLogisticoModal}
          draggable
        >
          <FormNivelLogisticoAlbaran
            intialData={2}
            onChange={(value: { nivel: number }) => {
              setFieldValue("albaranLogistico.niveles", value.nivel)
              setFieldValue("documentoType.screen", 4)
            }}
            onHide={() =>
              setFieldValue("modals.showAlbaranLogisticoModal", false)
            }
          />
        </Modal>
        <Modal
          key='modal-descuento'
          header={t("crear.facturaRec.modal.newField")}
          size='small'
          onHide={() => setFieldValue("modals.showDescuentoModal", false)}
          visible={values.modals.showDescuentoModal}
          draggable
        >
          <FormDescuentoDocuemnto
            onChange={(value: number) =>
              setFieldValue("descuento", value === 0 ? null : value)
            }
            descuento={values?.descuento}
            onHide={() => setFieldValue("modals.showDescuentoModal", false)}
          />
        </Modal>
        <Modal
          key='modal-retencion'
          header={t("crear.facturaRec.modal.newField")}
          size='small'
          maskClassName='!tw-z-50'
          onHide={() => setFieldValue("modals.showRetencionModal", false)}
          visible={values.modals.showRetencionModal}
          draggable
        >
          <FormRetencionDocuemnto
            onChange={({
              retencionTipoId,
              retencionPorcentaje,
            }: {
              retencionTipoId: string
              retencionPorcentaje: number
            }) => {
              setFieldValue("retencionTipoId", retencionTipoId)
              setFieldValue("retencionPorcentaje", retencionPorcentaje)
            }}
            retencionTipoId={values?.retencionTipoId}
            retencionPorcentaje={values?.retencionPorcentaje}
            onHide={() => setFieldValue("modals.showRetencionModal", false)}
            valuesForm={values}
          />
        </Modal>

        <Modal
          key='modal-pago-operacion'
          header={t("crear.facturaRec.modal.newField")}
          size='small'
          onHide={() => setFieldValue("modals.showFechaOperacionModal", false)}
          visible={values.modals.showFechaOperacionModal}
          maskClassName='!tw-z-20'
          draggable
        >
          <FormFechaPagoOperacion
            onChange={(value: number) => setFieldValue("fechaOperacion", value)}
            fechaOperacion={values?.fechaOperacion}
            fechaEmision={values?.fechaEmision}
            typeDocument={values.documentoType.type}
            onHide={() =>
              setFieldValue("modals.showFechaOperacionModal", false)
            }
          />
        </Modal>
        <Modal
          key='modal-observaciones'
          header={t("crear.facturaRec.modal.newField")}
          size='small'
          onHide={() => setFieldValue("modals.showObservacionesModal", false)}
          visible={values.modals.showObservacionesModal}
          draggable
        >
          <FormObservacionesDocumento
            onChange={(value: string) => setFieldValue("observaciones", value)}
            observaciones={values?.observaciones}
            onHide={() => setFieldValue("modals.showObservacionesModal", false)}
          />
        </Modal>
        <Modal
          key='modal-dias-pago'
          header={t("crear.facturaRec.modal.newField")}
          size='small'
          onHide={() => setFieldValue("modals.showDiasPagoModal", false)}
          visible={values.modals.showDiasPagoModal}
          draggable
        >
          <FormDiasPagoDocumento
            onChange={(value: number) =>
              setFieldValue("diasPago", value > 0 ? value : null)
            }
            diasPago={values?.diasPago}
            onHide={() => setFieldValue("modals.showDiasPagoModal", false)}
          />
        </Modal>

        <Modal
          key='modal-forma-pago'
          header={t("crear.facturaRec.modal.newField")}
          size='small'
          onHide={() => setFieldValue("modals.showFormaPagoModal", false)}
          visible={values.modals.showFormaPagoModal}
          maskClassName='!tw-z-40'
          draggable
        >
          <FormFormaPagoDocumento
            onChange={({
              formaPago,
              formaPagoIban,
              formaPagoCuentaId,
              formaPagoDescription,
            }: {
              formaPago?: number
              formaPagoIban?: string
              formaPagoCuentaId?: string
              formaPagoDescription?: string
            }) => {
              setFieldValue("formaPago", formaPago)
              setFieldValue("formaPagoIban", formaPagoIban)
              setFieldValue("formaPagoIbanInput", formaPagoCuentaId)
              setFieldValue("formaPagoDescription", formaPagoDescription)
            }}
            data={values}
            onHide={() => setFieldValue("modals.showFormaPagoModal", false)}
          />
        </Modal>
        <PrimeReactModal
          key='modal-logo'
          visible={values.modals.showLogoModal}
          className='tw-w-128 tw-rounded-lg tw-py-5 tw-px-6 tw-bg-white'
          baseZIndex={20}
          ptContext={MODAL_STYLES}
          closable={false}
          keepInViewport={false}
          header={
            <div className='tw-flex tw-justify-between tw-mb-6'>
              <p className='tw-text-2xl tw-font-medium tw-text-primary tw-m-0'>
                {t("crear.facturaRec.modal.newField")}
              </p>
              <ButtonPrimeReact
                className='!tw-p-0 !tw-min-w-0 !tw-bg-white !tw-border-none !tw-text-black'
                onClick={() => {
                  setFieldValue("modals.showLogoModal", false)
                  restartFileStatus()
                }}
              >
                <FontAwesomeIcon
                  icon={["fal", "xmark"]}
                  className='tw-w-5 tw-h-5'
                />
              </ButtonPrimeReact>
            </div>
          }
          footer={
            <div
              key='Actions'
              className='tw-flex tw-flex-row tw-justify-end tw-gap-3 tw-mt-4'
            >
              <ButtonPrimeReact
                label={`${t("crear.facturaRec.modal.cancelButton")}`}
                className='tw-h-12 !tw-bg-inherit !tw-border-none !tw-text-text tw-items-center'
                onClick={() => {
                  setFieldValue("modals.showLogoModal", false)
                  restartFileStatus()
                }}
              />
              <ButtonPrimeReact
                id='confirmModal'
                label={`${t("crear.facturaRec.modal.addButton")}`}
                className='tw-h-12 !tw-bg-primary !tw-border-none tw-text-simple-10 tw-items-center disabled:!tw-cursor-not-allowed disabled:tw-opacity-70'
                disabled={!fileStatus?.files?.length}
                onClick={async () => {
                  try {
                    if (fileStatus?.files && fileStatus.files[0]) {
                      const base64String = await encodeImageToBase64(
                        fileStatus?.files[0]
                      )
                      setFieldValue("modals.showLogoModal", false)
                      setFieldValue("logo", {
                        base64: base64String.split("base64,")[1],
                        mediaType: fileStatus?.files[0].type,
                      })
                      setFieldValue("logoAsBase64", base64String)
                      restartFileStatus()
                    }
                  } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error(
                      "Error al convertir la imagen a base64:",
                      error
                    )
                  }
                }}
              />
            </div>
          }
        >
          <label>{t("crear.facturaRec.modal.logoLabel")}</label>
          <DropzoneComponent
            fileStatus={fileStatus}
            setFileStatus={setFileStatus}
          />
        </PrimeReactModal>
      </AnimatePresence>
    </div>
  )
}

export default CardNuevosCamposDocumentosSetting
